<p-confirmDialog [ngClass]="{ 'custom-modal-delete': isDelete, 'custom-modal-repost': isRepost }"></p-confirmDialog>

<create-publication-modal-button
    *ngIf="editPost && isPublicationAPost()"
    [isEditMode]="true"
    [existingPublication]="publication"
    (afterPublicationUpdate)="updatePost($event)"
></create-publication-modal-button>

<update-comment-modal-button
    *ngIf="editPost && !isPublicationAPost()"
    [isEditMode]="true"
    [existingPublication]="publication"
    (afterCommentUpdate)="updatePost($event)"
></update-comment-modal-button>

<app-report-modal
    *ngIf="isReportModalVisible"
    [entityId]="publication.id"
    [entityOwner]="publicationOwnerFullName"
    [entityType]="'publication'"
></app-report-modal>

<div
    #gearEditPost
    class="custom-edit-post"
    *ngIf="showEditPost || isOnMobile"
    [ngClass]="publication.depth == 1 ? 'publicationTranslatePosition' : 'commentTranslatePosition'"
>
    <button
        type="button"
        pButton
        pRipple
        icon="pi pi-ellipsis-v"
        (click)="menu.toggle($event)"
        class="p-button-rounded p-button-text p-button-plain custom-gear"
        pTooltip="{{ 'clubs.page.tabs.discussion.post.modifyOrDelete' | translate }}"
        tooltipPosition="left"
    ></button>

    <p-menu id="menu" #menu [popup]="true" [model]="items" styleClass="custom-menu"></p-menu>
</div>
